import 'components/newIdentifyMethods/VerificationMethodContent/verificationMethodContent.scss';
import { IbanValidationContainer } from 'components/newIdentifyMethods/Iban/IbanValidationContainer';
import PostOffice from 'components/newIdentifyMethods/postOffice';
import { TransferInfoContainer } from 'components/newIdentifyMethods/transferInfo/TransferInfoContainer';
import Video from 'components/newIdentifyMethods/video/Video';
import {
    ROBO_IBAN,
    ROBO_TRANSFER,
    ROBO_VIDEOCALL,
    ROBO_VIDEOS,
    ROBO_VIDEOSELFIE,
    TC_IBAN,
    TC_VIDEOCALL,
    TC_VIDEOS,
    TC_VIDEOSELFIE,
    VIDEOCALLS_IN_1_BOX,
} from 'constants/featureFlagging';
import { COURIER, IBAN, TRANSFER_CERTIFICATE, VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';

import { CREDIT_CARD, ROBO } from 'constants/userProfile';
import React from 'react';

const VerificationMethodContent = ({ handleShowIbanErrorModal, selectedIdentification, storage, isIbanActive }) => {
    const renderIdentificationMethod = () => {
        switch (selectedIdentification) {
            case VIDEOCALLS_IN_1_BOX:
                return <Video withTabs={true} storage={storage} isIbanActive={isIbanActive} />;
            case ROBO_VIDEOS:
                return <Video withTabs={true} investmentType={ROBO} storage={storage} isIbanActive={isIbanActive} />;
            case TC_VIDEOS:
                return <Video withTabs={true} investmentType={CREDIT_CARD} isIbanActive={isIbanActive} />;

            case VIDEO_CALL:
            case TC_VIDEOCALL:
            case ROBO_VIDEOCALL:
                return <Video type={VIDEO_CALL} withTabs={false} storage={storage} isIbanActive={isIbanActive} />;
            case VIDEO_SELFIE:
            case TC_VIDEOSELFIE:
            case ROBO_VIDEOSELFIE:
                return <Video type={VIDEO_SELFIE} withTabs={false} storage={storage} isIbanActive={isIbanActive} />;
            case IBAN:
            case TC_IBAN:
            case ROBO_IBAN:
                return <IbanValidationContainer handleShowIbanErrorModal={handleShowIbanErrorModal} />;

            case TRANSFER_CERTIFICATE:
            case ROBO_TRANSFER:
                return <TransferInfoContainer />;

            case COURIER:
                return <PostOffice />;
        }
    };

    return (
        <div className="verification-method-content">
            <div className="info-description">
                <div className="info-description__content-wrapper">{renderIdentificationMethod()}</div>
            </div>
        </div>
    );
};

export default VerificationMethodContent;
